import { assets } from "../../assets";
import { BrandImage } from "../BrandImage/BrandImage";
import { copyright, externalLinkProps, type FooterLink, followsInApp } from "./footerLink";

export type { FooterLink } from "./footerLink";

export interface FooterProps {
  product?: string;
  company?: string;
  links?: FooterLink[];
  /** Follows a suite route without reloading the page. */
  onNavigate?: (href: string) => void;
}

const MARK_SIZE = 18;

/** Plain brand footer: product, copyright and a few links, nothing about the platform's state. */
export function Footer({
  product = "Nabble Suite",
  company = "Nabble SpA",
  links = [],
  onNavigate,
}: FooterProps): React.JSX.Element {
  return (
    <footer className="nb-footer">
      <div className="nb-footer-brand">
        <BrandImage className="nb-footer-mark" src={assets.iconAccent} width={MARK_SIZE} height={MARK_SIZE} />
        <span className="nb-footer-product">{product}</span>
        <span className="nb-footer-copy">{copyright(company, new Date().getFullYear())}</span>
      </div>
      {links.length > 0 ? <FooterLinks links={links} onNavigate={onNavigate} /> : null}
    </footer>
  );
}

function FooterLinks({ links, onNavigate }: { links: FooterLink[]; onNavigate?: (href: string) => void }): React.JSX.Element {
  return (
    <nav className="nb-footer-links" aria-label="Footer">
      {links.map((link) => (
        <a
          key={link.href}
          href={link.href}
          onClick={(e) => {
            if (!onNavigate || !followsInApp(link, e)) return;
            e.preventDefault();
            onNavigate(link.href);
          }}
          {...externalLinkProps(link)}
        >
          {link.label}
          {link.external ? <span className="nb-sr-only"> (opens in a new tab)</span> : null}
        </a>
      ))}
    </nav>
  );
}
